import Vue from 'vue'
import Router from 'vue-router'
import Services from './services'
import List from '@/components/list'
import Item from '@/components/item'
import Error from '@/components/not-found'

Vue.use(Router)

let data;

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'list',
      component: List,
      props: () => ({ data: data}),
    },
    {
      path: '/not-found',
      name: 'not-found',
      component: Error,
    },
    {
      path: '/:id',
      name: 'item',
      component: Item,
      props: () => ({ data: data}),
      beforeEnter: (to, from, next) => {
        Services.item(to.params.id)
          .then(res => {
            if(res != null) {
              data = res
              next()
            } else {
              throw new Error("no result")
            }
          }).catch(() => {
            next({ path: '/not-found' })
          })
      }
    },
    {
      path: '*',
      name: 'err',
      redirect: '/not-found',
    }
  ],
  scrollBehavior () {
    return { x: 0, y: 0 };
  }
})

router.beforeEach((to, from, next) => {
  if(!Vue.cookie.get('cccf_auth')) {
    window.location = process.env.VUE_APP_SITE_URL
  } else {
    next()
  }
})

export default router
